import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import * as MicrosoftGraphClient from '@microsoft/microsoft-graph-client';
import {Injectable} from '@angular/core';
import {MsalService} from '@azure/msal-angular';
import {NGXLogger} from 'ngx-logger';
import {from, Observable} from 'rxjs';
import {MsalCustomInterceptor} from '../../pages/auth/msal-custom-interceptor';

@Injectable()
/**
 * Handles microsoftgraphservice for this module.
 */
export class MicrosoftGraphService {
  url = 'https://graph.microsoft.com/v1.0';

  constructor(private logger: NGXLogger, private authService: MsalService, private interceptor: MsalCustomInterceptor) {
  }

  /**
   * Gets client for the current workflow.
   */
  getClient(): MicrosoftGraphClient.Client {
    return MicrosoftGraphClient.Client.init({
      authProvider: (done) => {
        const scopes = this.interceptor.getScopesForEndpoint(this.url, 'GET');

        if (scopes !== null) {
          this.authService.acquireTokenSilent({scopes})
            .subscribe({next: (result) => {
              this.logger.trace(`MSAL token acquired silently for Microsoft Graph Service: ${JSON.stringify(result)}`);
              done(null, result.accessToken); // first parameter takes an error if you can't get an access token
            }});
        }
      },
    });
  }

  /**
   * Gets m e for the current workflow.
   */
  getMe(): Observable<MicrosoftGraph.User> {
    const client = this.getClient();
    return from(client
      .api('me')
      .get()
      .then((res => {
        return res;
      })),
    );
  }

  /**
   * Gets myphoto for the current workflow.
   */
  getMyPhoto(): Observable<MicrosoftGraph.ProfilePhoto> {
    const client = this.getClient();
    return from(client
      .api('me/photo')
      .get()
      .then((res => {
        return res;
      })),
    );
  }

  /**
   * Handles sendmail for this module.
   */
  sendMail(mail: MicrosoftGraph.Message) {
    const client = this.getClient();
    return from(client
      .api('me/sendmail')
      .post({message: mail}),
    );
  }

}


